<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center flex-wrap gap-3">
          <h1 class="title-default">Configurações da NF-e</h1>
          @if (podeVisualizar && !podeAlterar) {
            <span
              class="status-badge badge-cinza"
              matTooltip="Seu perfil pode consultar estas configurações, mas não alterá-las.">
              <mat-icon class="material-symbols-outlined">lock</mat-icon>
              Somente leitura
            </span>
          }
        </div>
        <p class="welcome-message">
          <button
            mat-icon-button
            type="button"
            (click)="voltar()"
            matTooltip="Voltar para Configurações de Notas Fiscais"
            aria-label="Voltar para Configurações de Notas Fiscais">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Padrões, validações e impressão das NF-e da empresa, aplicados às notas criadas depois de salvar.
        </p>
      </div>
    </div>

    @if (!podeVisualizar) {
      <app-alert-card type="warning">
        Você não tem permissão para visualizar as configurações de notas fiscais.
      </app-alert-card>
    } @else if (isLoading) {
      @for (i of [1, 2, 3]; track i) {
        <div class="section-container">
          <app-loading-box height="30" width="240" marginTop="0"></app-loading-box>
          <app-loading-box height="22" width="55%" marginTop="16"></app-loading-box>
          <app-loading-box height="22" width="48%" marginTop="12"></app-loading-box>
          <app-loading-box height="22" width="52%" marginTop="12"></app-loading-box>
        </div>
      }
    } @else {
      <form [formGroup]="form">
        <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

        <!-- ================= Padrões do documento ================= -->
        <div class="section-container" id="padroes-documento">
          <div class="section-title">
            <mat-icon class="material-symbols-outlined">description</mat-icon>
            <span>Padrões do documento</span>
          </div>
          <p class="section-sub-title">
            Valores que toda nova NF-e já traz preenchidos. Podem ser alterados no próprio documento e, na nota
            gerada pela venda, o valor da venda prevalece.
          </p>

          <div class="row g-3">
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Indicador de presença padrão</mat-label>
                <mat-select formControlName="idIndicadorPresencaComprador">
                  @for (item of opcoesIndicadorPresenca; track item.id) {
                    <mat-option [value]="item.id">{{ item.codigo }} - {{ item.descricao }}</mat-option>
                  }
                </mat-select>
                @if (form.get('idIndicadorPresencaComprador')?.hasError('required')) {
                  <mat-error>Escolha o indicador de presença padrão.</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Padrão do campo "frete por conta"</mat-label>
                <mat-select formControlName="idModalidadeFrete">
                  @for (item of opcoesModalidadeFrete; track item.id) {
                    <mat-option [value]="item.id">{{ item.codigo }} - {{ item.descricao }}</mat-option>
                  }
                </mat-select>
                @if (form.get('idModalidadeFrete')?.hasError('required')) {
                  <mat-error>Escolha o padrão do frete.</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Espécie padrão dos volumes transportados</mat-label>
                <input matInput formControlName="especieVolumePadrao" maxlength="60" placeholder="Ex.: Caixa" />
              </mat-form-field>
            </div>
          </div>

          <div class="toggle-content">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isSubstituirEnderecoEntrega"
              >Substituir endereço do destinatário pelo endereço de entrega ao gerar a nota fiscal pelo pedido de
              venda</mat-slide-toggle
            >
            <span class="info-text"
              >Vale só para a nota gerada pela venda. Quando a venda não tem endereço de entrega, a nota usa o
              endereço principal do cliente.</span
            >
          </div>
        </div>

        <!-- ================= Observações automáticas ================= -->
        <div class="section-container" id="observacoes-automaticas">
          <div class="section-title">
            <mat-icon class="material-symbols-outlined">notes</mat-icon>
            <span>Observações automáticas</span>
          </div>
          <p class="section-sub-title">
            Textos que o sistema acrescenta às observações da nota gerada pela venda, sem substituir o conteúdo
            existente.
          </p>

          <div class="toggle-content">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isObservacaoOrdemCompra"
              >Acrescentar o número da ordem de compra nas observações</mat-slide-toggle
            >
            <span class="info-text">Nada é inserido quando o pedido de venda não tem ordem de compra.</span>
          </div>

          <div class="toggle-content">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isObservacaoNumeroVenda"
              >Acrescentar o número da venda nas observações</mat-slide-toggle
            >
            <span class="info-text">Inclui o número do pedido de venda que originou a nota.</span>
          </div>
        </div>

        <!-- ================= Validações e bloqueios ================= -->
        <div class="section-container" id="validacoes-bloqueios">
          <div class="section-title">
            <mat-icon class="material-symbols-outlined">rule</mat-icon>
            <span>Validações e bloqueios</span>
          </div>

          <div class="toggle-content">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isValidarNcm"
              >Validar campo NCM em notas fiscais</mat-slide-toggle
            >
            <span class="info-text"
              >Impede a emissão enquanto houver item sem NCM válido. Desativada, o erro só aparece na rejeição da
              Sefaz.</span
            >
          </div>

          <div class="toggle-content">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isBloquearEdicaoNumero"
              >Bloquear edição do número da nota fiscal</mat-slide-toggle
            >
            <span class="info-text"
              >A numeração segue o emissor. Editar o número à mão pode quebrar a sequência, que só se resolve com
              inutilização na Sefaz.</span
            >
          </div>

          <div class="toggle-content">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isBloquearItensDiferentesVenda"
              >Bloquear geração de nota fiscal com itens diferentes da venda</mat-slide-toggle
            >
            <span class="info-text"
              >Impede a emissão quando os produtos ou as quantidades não forem iguais aos da venda. Preço e desconto
              podem ser alterados. Ativado, permite escolher abaixo os perfis que podem liberar a divergência.</span
            >
          </div>

          <app-perfil-autorizado-lista
            [perfis]="opcoesPerfis"
            [value]="idsPerfilLiberacaoDivergencia"
            [disabled]="!podeAlterar || !configCarregada || !isBloqueioItensAtivo"
            titulo="Perfis que podem liberar a divergência"
            textoVazio="Nenhum perfil configurado"
            textoVazioApoio="O bloqueio é absoluto: ninguém consegue salvar uma nota divergente da venda."
            (valueChange)="onPerfisLiberacaoChange($event)">
          </app-perfil-autorizado-lista>
        </div>

        <!-- ================= Campos por segmento de atuação ================= -->
        <div class="section-container" id="campos-segmento">
          <div class="section-title">
            <mat-icon class="material-symbols-outlined">agriculture</mat-icon>
            <span>Campos por segmento de atuação</span>
          </div>

          <app-alert-card type="info">
            Combustíveis e medicamentos não são configurados aqui: o cadastro de produto exibe os dados da ANP
            quando o NCM está na Tabela ANP e os de medicamento quando o NCM começa com 3004, e o item da nota herda
            os dados do produto.
          </app-alert-card>

          <div class="toggle-content">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isExibirDefensivosAgricolas"
              >Exibir campos referentes a defensivos agrícolas</mat-slide-toggle
            >
            <span class="info-text"
              >Para quem vende agrotóxicos: a nota passa a ter os receituários agronômicos (até 20 por nota).</span
            >
          </div>

          <div class="toggle-content">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isExibirGuiaTransito"
              >Exibir campos referentes a guia de trânsito</mat-slide-toggle
            >
            <span class="info-text"
              >Para quem transporta animais, vegetais ou madeira: a nota passa a ter os campos da guia (GTA, TTA, DTA,
              ATV, PTV, GTV e Guia Florestal).</span
            >
          </div>
        </div>

        <!-- ================= Envio e compartilhamento ================= -->
        <div class="section-container" id="envio-compartilhamento">
          <div class="section-title">
            <mat-icon class="material-symbols-outlined">forward_to_inbox</mat-icon>
            <span>Envio e compartilhamento</span>
          </div>

          <div class="sub-section-container">
            <div class="sub-section-title">
              <mat-icon class="material-symbols-outlined">mail</mat-icon>
              <span>E-mail padrão como cópia no envio das notas</span>
            </div>
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>E-mails para cópia</mat-label>
              <mat-chip-grid #gridEmails [disabled]="!podeAlterar || !configCarregada">
                @for (email of emailsCopia; track email; let i = $index) {
                  <mat-chip-row (removed)="removerEmail(i)" [disabled]="!podeAlterar || !configCarregada">
                    {{ email }}
                    <button matChipRemove type="button" [attr.aria-label]="'Remover ' + email">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                }
                <input
                  placeholder="nome@empresa.com.br"
                  [matChipInputFor]="gridEmails"
                  [matChipInputSeparatorKeyCodes]="separadoresEmail"
                  [matChipInputAddOnBlur]="true"
                  [disabled]="!podeAlterar || !configCarregada"
                  (matChipInputTokenEnd)="adicionarEmails($event)" />
              </mat-chip-grid>
              <mat-hint>Pressione Enter, vírgula ou ponto e vírgula para incluir cada endereço.</mat-hint>
            </mat-form-field>
            @if (erroEmail) {
              <span class="d-block small text-danger">{{ erroEmail }}</span>
            }
          </div>

          <div class="sub-section-container">
            <div class="sub-section-title">
              <mat-icon class="material-symbols-outlined">download</mat-icon>
              <span>Autorizados a baixar o XML das notas</span>
              <div class="section-title-actions ms-auto">
                <span
                  class="status-badge badge-cinza"
                  [matTooltip]="'A Sefaz aceita no máximo ' + limiteAutorizadosXml + ' autorizados por nota.'">
                  {{ autorizadosXml.length }}/{{ limiteAutorizadosXml }}
                </span>
                <span
                  [matTooltip]="
                    autorizadosXml.length >= limiteAutorizadosXml
                      ? 'Limite de ' + limiteAutorizadosXml + ' autorizados atingido.'
                      : 'Adicionar autorizado'
                  "
                  matTooltipPosition="above">
                  <button
                    type="button"
                    mat-button
                    class="btn-section"
                    (click)="adicionarAutorizado()"
                    [disabled]="!podeAdicionarAutorizado">
                    <mat-icon class="material-symbols-outlined">add</mat-icon> Adicionar
                  </button>
                </span>
              </div>
            </div>
            <p class="sub-section-sub-title">
              Contador, matriz, transportadora ou auditoria que podem baixar o XML pelo portal da Receita Federal. A
              autorização vai dentro do XML e vale para as notas emitidas depois de salvar.
            </p>

            @if (autorizadosXml.length > 0) {
              <div class="desktop-view table-responsive">
                <table mat-table [dataSource]="autorizadosXml" class="w-100">
                  <ng-container matColumnDef="documento">
                    <th mat-header-cell *matHeaderCellDef>CPF ou CNPJ</th>
                    <td mat-cell *matCellDef="let linha">
                      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                        <input
                          matInput
                          [(ngModel)]="linha.documento"
                          [ngModelOptions]="{ standalone: true }"
                          [disabled]="!podeAlterar || !configCarregada"
                          maxlength="18"
                          placeholder="000.000.000-00"
                          (ngModelChange)="onAutorizadoAlterado()"
                          (blur)="validarDocumento(linha)" />
                      </mat-form-field>
                      @if (linha.erroDocumento) {
                        <span class="d-block small text-danger">{{ linha.erroDocumento }}</span>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="nome">
                    <th mat-header-cell *matHeaderCellDef>Nome</th>
                    <td mat-cell *matCellDef="let linha">
                      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                        <input
                          matInput
                          [(ngModel)]="linha.nome"
                          [ngModelOptions]="{ standalone: true }"
                          [disabled]="!podeAlterar || !configCarregada"
                          maxlength="120"
                          placeholder="Ex.: Escritório contábil"
                          (ngModelChange)="onAutorizadoAlterado()"
                          (blur)="validarNome(linha)" />
                      </mat-form-field>
                      @if (linha.erroNome) {
                        <span class="d-block small text-danger">{{ linha.erroNome }}</span>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                    <td mat-cell *matCellDef="let linha; let i = index" class="text-center w-actions">
                      <button
                        mat-icon-button
                        type="button"
                        (click)="removerAutorizado(i)"
                        [disabled]="!podeAlterar || !configCarregada"
                        matTooltip="Remover autorizado">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="colunasAutorizados"></tr>
                  <tr mat-row *matRowDef="let row; columns: colunasAutorizados"></tr>
                </table>
              </div>

              <div class="mobile-view">
                @for (linha of autorizadosXml; track $index; let i = $index) {
                  <div class="card-mobile mb-3">
                    <div class="card-header-mobile d-flex justify-content-between align-items-center">
                      <strong>Autorizado {{ i + 1 }}</strong>
                      <button
                        mat-icon-button
                        type="button"
                        (click)="removerAutorizado(i)"
                        [disabled]="!podeAlterar || !configCarregada"
                        matTooltip="Remover autorizado">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                      </button>
                    </div>
                    <div class="card-body-mobile p-3">
                      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                        <mat-label>CPF ou CNPJ</mat-label>
                        <input
                          matInput
                          [(ngModel)]="linha.documento"
                          [ngModelOptions]="{ standalone: true }"
                          [disabled]="!podeAlterar || !configCarregada"
                          maxlength="18"
                          (ngModelChange)="onAutorizadoAlterado()"
                          (blur)="validarDocumento(linha)" />
                      </mat-form-field>
                      @if (linha.erroDocumento) {
                        <span class="d-block small text-danger">{{ linha.erroDocumento }}</span>
                      }
                      <mat-form-field appearance="outline" class="w-100 mt-3" subscriptSizing="dynamic">
                        <mat-label>Nome</mat-label>
                        <input
                          matInput
                          [(ngModel)]="linha.nome"
                          [ngModelOptions]="{ standalone: true }"
                          [disabled]="!podeAlterar || !configCarregada"
                          maxlength="120"
                          (ngModelChange)="onAutorizadoAlterado()"
                          (blur)="validarNome(linha)" />
                      </mat-form-field>
                      @if (linha.erroNome) {
                        <span class="d-block small text-danger">{{ linha.erroNome }}</span>
                      }
                    </div>
                  </div>
                }
              </div>
            } @else {
              <app-empty-state
                icon="person_off"
                title="Nenhum autorizado"
                subtitle="Só o emitente e o destinatário conseguem baixar o XML das notas."></app-empty-state>
            }
          </div>
        </div>

        <!-- ================= DANFE e impressão ================= -->
        <div class="section-container" id="danfe-impressao">
          <div class="section-title">
            <mat-icon class="material-symbols-outlined">print</mat-icon>
            <span>DANFE e impressão</span>
          </div>
          <p class="section-sub-title">Altera apenas a impressão do DANFE, nunca o XML transmitido.</p>

          <div class="row">
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fonte utilizada para impressão</mat-label>
                <mat-select formControlName="idTipoFonteDanfe">
                  @for (fonte of opcoesFonteDanfe; track fonte.idTipoFonteDanfe) {
                    <mat-option [value]="fonte.idTipoFonteDanfe">{{ fonte.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="toggle-content">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isRemoverEnderecoDestinatarioEtiqueta"
              >Remover endereço do destinatário na DANFE etiqueta</mat-slide-toggle
            >
          </div>

          <div class="toggle-content">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isRemoverEnderecoEmitenteEtiqueta"
              >Remover endereço do emitente na DANFE etiqueta</mat-slide-toggle
            >
          </div>

          <div class="toggle-content">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isRemoverValorTotalEtiqueta"
              >Remover valor total na DANFE etiqueta</mat-slide-toggle
            >
            <span class="info-text"
              >As remoções na etiqueta são responsabilidade da empresa e podem afetar a conferência na expedição e no
              transporte.</span
            >
          </div>

          <div class="toggle-content">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isRemoverGtinDanfe"
              >Remover GTIN/EAN do produto na impressão da DANFE</mat-slide-toggle
            >
            <span class="info-text">Vale para a impressão do DANFE em qualquer formato, não só na etiqueta.</span>
          </div>
        </div>
      </form>
    }
  </div>
</div>

@if (podeAlterar) {
  <app-footer-action
    [isLoadingSalvar]="isSaving"
    [isSalvarDisabled]="!isDirty || !configCarregada || isLoading"
    (salvar)="salvar()"
    (cancelar)="voltar()">
  </app-footer-action>
}
